export const COPY = {
  backToLogin: 'Back to login',
  goHome: 'Go home',
  loginAsDifferentUser: 'Login as a different user'
}
